export const PROPERTY = 'PROPERTY';
export const ASSOCIATION = 'ASSOCIATION';
export const ASSOCIATION_LABEL = 'ASSOCIATION_LABEL';